import { render, staticRenderFns } from "./aba-eventos-grade.vue?vue&type=template&id=e8f79496"
import script from "./aba-eventos-grade.vue?vue&type=script&lang=js"
export * from "./aba-eventos-grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports